// @mui
import { Box, BoxProps, Grid, Typography } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// config
import { HEADER, NAV } from '../../config-global';
// components
import { useSettingsContext } from '../../components/settings';

import Logo from '../../components/logo';

import './footer.css';

import metodosPagamento from './img/metodospagamento.png'
import Footer from './footer';
// ----------------------------------------------------------------------

const SPACING = 8;

type Props = BoxProps & {
  contributionOffset?: number;
};

export default function Main({ children, sx, contributionOffset = 0, ...other }: Props) {
  const { themeLayout } = useSettingsContext();

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const isDesktop = useResponsive('up', 'lg');

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          pt: `${HEADER.H_MOBILE + SPACING + contributionOffset}px`,
          pb: `${HEADER.H_MOBILE + SPACING}px`,
          ...(isDesktop && {
            px: 2,
            pt: `${HEADER.H_DASHBOARD_DESKTOP + 80 + contributionOffset}px`,
            pb: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (

    <Box
      component="main"
      className="mainGeral"
      sx={{
        flexGrow: 1,
        pt: `${HEADER.H_MOBILE + SPACING + contributionOffset}px`,
        pb: `${HEADER.H_MOBILE + SPACING}px`,
        ...(isDesktop && {
          px: 2,
          pt: `${HEADER.H_DASHBOARD_DESKTOP + SPACING + contributionOffset}px`,
          pb: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`,
          }),
        }),

        ...sx,
      }}
      {...other}
    >
      {children}
      <Footer/>
    </Box>
  );
}
